// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"authority-component_uk-open__LFoE5","grecaptcha-badge":"authority-component_grecaptcha-badge__HQLi0","authority":"authority-component_authority__s2kUO","noTitle":"authority-component_noTitle__z0jDl","title":"authority-component_title__judnO","logos":"authority-component_logos__2WVqe"};
    if(module.hot) {
      // 1754915981290
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  